import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./NewPassword.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import moment from "moment";
import CountDownTimer, { Countdown } from "../../../../components/Timer/Timer";
// import forgetBackImg from "../../assets/forgetBackImg.png";
const NewPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [current, setCurrent] = useState(0);
  const [newPassword, setNewPassword] = useState();
  const [newPassVisible, setNewPassVisible] = useState(false);
  const [confirmPass, setConfirmPass] = useState();
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [timer, setTimer] = useState("");
  const location = useLocation();
  let token = location?.state?.data?.data?.token;
  let email = location?.state?.location?.state?.email;
  const handleOnChangePassword = () => {
    let userData = {
      token: token,
      email: email,
      newPassword: newPassword,
      confirmPassword: confirmPass,
    };
    if (!newPassword || !confirmPass) {
      dispatch(
        showAlert({ message: "All fields are mandatory.", type: "Error" })
      );
    } else if (
      /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/.test(
        newPassword
      ) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Passwords",
          message:
            "Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!",
        })
      );
    } else if (newPassword !== confirmPass) {
      dispatch(
        showAlert({
          title: "Password!",
          message: "Password and confirm password must be match",
        })
      );
    } else {
      dispatch(AuthMiddleware.changePassword(userData))
        .then((data) => {
          navigate("/");
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  // const duration = moment.duration(5, "m");
  // let timeValue = "";
  // const intervalId = setInterval(() => {
  //   duration.subtract(1, "s");
  //   const inMilliseconds = duration.asMilliseconds();
  //   // "mm:ss:SS" will include milliseconds
  //   console.log(moment.utc(inMilliseconds).format("mm[m]:ss[s]"));
  //   timeValue = moment.utc(inMilliseconds).format("mm[m]:ss[s]");
  //   // setTimer(moment.utc(inMilliseconds).format("mm[m]:ss[s]"));
  //   if (inMilliseconds !== 0) return;
  //   clearInterval(intervalId);
  //   console.warn("Times up!");
  // }, 1000);

  // console.log({ timeValue });

  return (
    <Box boxClass={styles.box}>
      <div className={styles.header}>
        <IoIosArrowBack
          color="var(--black-color)"
          size={30}
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
      </div>
      <div className={styles.headingDiv}>
        <TextComponent text={"Enter New Password"} textClass={styles.heading} />
        <TextComponent
          text={
            "Please enter new password and confirm password to change password"
          }
          textClass={styles.subHeading}
        />
        {/* <TextComponent
          text={`code wiil be expire in`}
          textClass={styles.subHeading2}
        ></TextComponent> */}
        {/* <Countdown  /> */}
        <InputField
          label={"Enter New Password"}
          placeholder={"••••••••••••••••"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          rightIcon={
            newPassVisible ? (
              <BsEyeSlashFill color="var(--light-grey)" size={15} />
            ) : (
              <BsEyeFill color="var(--light-grey)" size={15} />
            )
          }
          type={newPassVisible ? "password" : "text"}
          onRightIconPress={(e) => setNewPassVisible(!newPassVisible)}
        />
        <InputField
          label={"Confirm Password"}
          placeholder={"••••••••••••••••"}
          value={confirmPass}
          onChange={(e) => setConfirmPass(e.target.value)}
          rightIcon={
            confirmPassVisible ? (
              <BsEyeSlashFill color="var(--light-grey)" size={15} />
            ) : (
              <BsEyeFill color="var(--light-grey)" size={15} />
            )
          }
          type={confirmPassVisible ? "password" : "text"}
          onRightIconPress={(e) => setConfirmPassVisible(!confirmPassVisible)}
        />
        <SubmitButton
          title={"Change Password"}
          btnClass={styles.btn}
          onClick={handleOnChangePassword}
        />
      </div>
    </Box>
  );
};
export default NewPassword;
